// extracted by mini-css-extract-plugin
export default {"container":"DriverFailedDeliveries_container__SwVxc"};